import React, { useState, useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom'
import * as _usr_const from '../../config/usr-constant';
import * as _view_action from '../../helper/viewAction';
import * as _debug from '../../helper/debug';
import axios from 'axios';
import Paper from '@material-ui/core/Paper';
import Loading from '../../components/View/Loading';
import HeadButtonGroups, { HeadButtonGroupBtnActionsProps } from '../../components/View/HeadButtonGroups';
import ZshLogs from '../../components/View/ZshLogs';
import ErrorView from '../../components/View/ErrorView';

type InflowSourceTypeProps = {
  id: number;
  name: string;
}

type InflowSourceMasterDataProps = {
  id: number;
  common_parent_id: number;
  inflow_source_type_id: number;
  name: string;
  inflow_source_type_name: string;
  inflow_source_type: InflowSourceTypeProps;
  common_parent: any;
}
function InflowSourceMastersView({ history, match }: RouteComponentProps<{ id: string }>) {

  const unmounted = useRef(false);
  const source = useRef(axios.CancelToken.source());

  const [isInit, setInit] = useState(true);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<InflowSourceMasterDataProps>({
    id: 0,
    common_parent_id: 0,
    inflow_source_type_id: 0,
    name: '',
    inflow_source_type_name: '',
    inflow_source_type: {
      id: 0,
      name: ''
    },
    common_parent: {}
  });
  const [dataMounted, setDataMounted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [errorStatus, setErrorStatus] = useState(0);

  // clean up
  useEffect(() => {
    const clSource = Object.assign({}, source.current);
    return () => {
      // cancel axios get
      clSource.cancel('cancel inflow source master get');
      unmounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      setLoading(true);
      _view_action.getViewData<InflowSourceMasterDataProps>({
        unmounted,
        source,
        dataKey: 'inflowSourceMaster',
        path: _usr_const.ApiUrl + 'inflow-source-masters/view/' + match.params.id + '/index.json',
        setData,
        setDataMounted,
        setErrorStatus,
        setErrorMsg,
        setLoading
      })
      .catch((error) => {
        _debug.debugAxiosError(error);
      });
      setInit(false);
    }
  }, [isInit, match.params.id]);

  const btnActions: HeadButtonGroupBtnActionsProps[] = [
    {
      type: 'edit',
      func: (): void => {
        history.push('/inflow-source-masters/' + match.params.id + '/edit');
      },
      role: {
        name: 'InflowSourceMasters',
        action: 'edit',
      },
    },
  ];

  return (
    <div className="content-1">
      <Loading loading={loading} />
      {
        dataMounted &&
        <div>
          <HeadButtonGroups
            history={history}
            btnActions={btnActions}
          />
          <Paper>
            <div className="view-content-in">
              <table className="table-1">
                <tbody>
                  <tr>
                    <th>ID</th>
                    <td>{data.id}</td>
                  </tr>
                  <tr>
                    <th>流入元区分</th>
                    <td>{data.inflow_source_type_name}</td>
                  </tr>
                  <tr>
                    <th>流入元名</th>
                    <td>{data.name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Paper>
          <ZshLogs logs={data.common_parent.logs} />
        </div>
      }
      {
        errorMsg !== '' &&
        <div>
          <ErrorView
            history={history}
            errorStatus={errorStatus}
            errorMsg={errorMsg}
          />
        </div>
      }
    </div>
  )
}

export default InflowSourceMastersView;